import { z } from 'zod';

const PERCENTAGE_VALUE_ERROR = 'Un pourcentage ne peut être compris qu\'entre 0 et 100';
const PERCENTAGE_FORMAT_ERROR = 'Un pourcentage ne peut être qu\'un nombre entre 0 et 100 avec deux décimales après la virgule';

export const Z_PERCENTAGE = (
  minError: string = PERCENTAGE_VALUE_ERROR,
  maxError: string = PERCENTAGE_VALUE_ERROR,
  decimalError: string = PERCENTAGE_FORMAT_ERROR,
  invalidError: string = PERCENTAGE_FORMAT_ERROR,
) => z
  .coerce
  .string()
  .min(1, { message: 'Ce champ est requis' })
  .transform((val) => val.replace(',', '.').trim()) // Remplacer virgule par point et nettoyer
  .refine(
    (val) => !isNaN(Number(val)) && val !== '',
    { message: invalidError },
  )
  .transform((val) => Number(val))
  .refine(
    (val) => val >= 0,
    { message: minError },
  )
  .refine(
    (val) => val <= 100,
    { message: maxError },
  )
  .refine(
    (val) => {
      const decimalPlaces = val.toString().split('.')[1]?.length || 0;
      return decimalPlaces <= 2;
    },
    { message: decimalError },
  );